import { useQuery } from "@tanstack/react-query";
import { getClientById } from "../api/CLIENTS/clients";

export const useClient = (clientId) => {
  return useQuery({
    queryKey: ['client', clientId],
    queryFn: () => getClientById(clientId),
    enabled: !!clientId, 
  });
};